import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  SubcategoriesListRequest,
  CreateSubcategoryRequest,
  DeleteSubcategoryRequest,
  SubcategoryResponse,
} from "../types/api/catalogs";

const path = `/metadata/admin/${process.env.REACT_APP_API_VERSION}/catalogs`;

//Справочники (Подразделы) - Получить список
export function fetchSubcategories(params: SubcategoriesListRequest) {
  return mainAPI.get<SubcategoryResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Справочники (Подразделы)- Получить запись
export function fetchSubcategory(catalog_id: string) {
  return mainAPI.get(`${path}/${catalog_id}`).then(
    (res) => {
      return Promise.resolve(res.data as SubcategoryResponse);
    },
    (error) => handleApiError(error)
  );
}

// Справочники (Подразделы) - Создать
export function createSubcategory(request: CreateSubcategoryRequest) {
  return mainAPI.post<SubcategoriesListRequest>(`${path}`, request).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при создании подраздела")
      );
    }
  );
}

// Справочники (Подразделы) - Изменить
export function editSubcategory(
  catalog_id: string,
  request: CreateSubcategoryRequest
) {
  return mainAPI
    .put<SubcategoriesListRequest>(`${path}/${catalog_id}`, request)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при изменении подраздела")
        );
      }
    );
}

// Справочники (Подразделы) - Удалить
export function deleteSubcategory(request: DeleteSubcategoryRequest) {
  return mainAPI.post(`${path}/delete`, request).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при удалении подраздела")
      );
    }
  );
}
